export default "__VITE_PUBLIC_ASSET__879b0a97__"